/* @flow */
import * as React from 'react';
import Label from '../../../atoms/label/react/Label';

export type FromGroupType = {
  label: string,
  labelSettings?: { htmlFor?: string, id?: string, hidden?: boolean },
  invalid?: boolean,
  disabled?: boolean,
  required?: boolean,
  children: React.Node,
  error?: React.Node,
  fieldset?: boolean,
};

const FormGroup = ({
  label,
  labelSettings,
  invalid,
  disabled,
  required,
  children,
  error,
  fieldset,
  ...rest
}: FromGroupType) => {
  const HtmlTag = fieldset ? 'fieldset' : 'div';
  return (
    <HtmlTag {...rest} className="form-group">
      {label && (
        <Label
          {...labelSettings}
          disabled={disabled}
          invalid={invalid}
          required={required}
          tag={fieldset ? 'legend' : 'label'}
        >
          {label}
        </Label>
      )}
      {fieldset ? (
        <div className="form-group__items">{children}</div>
      ) : (
        <div className="form-group__input">{children}</div>
      )}

      {error && (
        <p
          className="form-group__error"
          id={
            labelSettings &&
            labelSettings.htmlFor &&
            `${labelSettings.htmlFor}-error`
          }
        >
          {error}
        </p>
      )}
    </HtmlTag>
  );
};

export default FormGroup;
